module.exports = __webpack_public_path__ + "static/img/21.4d5a432.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/21.png
// module id = pQn7
// module chunks = 0